var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("QQ钱包")]),_c('p',[_vm._v("用于 QQ 钱包活动")])])])])
}]

export { render, staticRenderFns }